import { BankingProductsByTypeResponse } from '@repo/accounts-types'
import { ApiResponse, GenericOperationState } from '@repo/core'
import { RootState } from '../../../../store/types'

export const bankingProductsDataSelectorConfig = {
  bankingProductsDataSelector: {
    getRootPath: function (
      state: RootState,
    ): GenericOperationState<ApiResponse<BankingProductsByTypeResponse> | null> {
      return state.accounts.detail.read.bankingProducts
    },
  },
}
